import React from 'react'

export function PanelSection({ title, children }) {
  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-3 shadow-sm">
      <h4 className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">{title}</h4>
      <div className="space-y-2.5">{children}</div>
    </section>
  )
}

export function CheckboxRow({ label, name, checked, onChange }) {
  return (
    <label className="flex items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">
      <span>{label}</span>
      <input type="checkbox" name={name} checked={checked} onChange={onChange} className="h-4 w-4 rounded border-slate-300" />
    </label>
  )
}

export function LabeledSelect({ label, name, value, onChange, options }) {
  return (
    <label className="block text-sm text-slate-700">
      <div className="mb-1.5 font-medium">{label}</div>
      <select name={name} value={value} onChange={onChange} className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 outline-none transition focus:border-slate-400">
        {options.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </label>
  )
}

export function NumberField({ label, name, value, onChange, min, max }) {
  return (
    <label className="block text-sm text-slate-700">
      <div className="mb-1.5 flex items-center justify-between">
        <span className="font-medium">{label}</span>
        <span className="text-xs text-slate-500">{value}</span>
      </div>
      <input type="range" name={name} min={min} max={max} value={value} onChange={onChange} className="w-full" />
    </label>
  )
}

export function ColorField({ label, name, value, onChange }) {
  return (
    <label className="block text-sm text-slate-700">
      <div className="mb-1.5 font-medium">{label}</div>
      <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white px-3 py-2">
        <input type="color" name={name} value={value} onChange={onChange} className="h-8 w-10 rounded border-0 bg-transparent p-0" />
        <span className="text-xs text-slate-500">{value}</span>
      </div>
    </label>
  )
}

